import React from 'react';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { SidebarListItem } from 'components/Layout/Sidebar/SidebarListItem';
import { SidebarList } from 'components/Layout/Sidebar/SidebarList';
import { useSelector } from 'react-redux';
import { userDetailsSelector } from 'store/slices/userDetailsSlice';
import { buildContactUsLink } from 'components/Layout/Sidebar/utilities';
import { useAppContext } from 'services/context';
import { CONTACT_US_URL } from 'components/Layout/Sidebar/constants';
import { useAuth0 } from '@auth0/auth0-react';

export const ContactUsList = () => {
  const userDetails = useSelector(userDetailsSelector);
  const { isAuthenticated } = useAuth0();
  const { isLoggedIn } = useAppContext();

  const link =
    isLoggedIn || isAuthenticated
      ? buildContactUsLink(userDetails)
      : CONTACT_US_URL;

  return (
    <SidebarList>
      <SidebarListItem
        Icon={ContactSupportIcon}
        name="Contact Us"
        path={link}
        isExternal
      />
    </SidebarList>
  );
};
